module.exports = __webpack_public_path__ + "assets/img/17-s.1b38231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/17-s.jpg
// module id = cKO2
// module chunks = 0